import { render, staticRenderFns } from "./ManageWikiList.vue?vue&type=template&id=5919d2a4"
import script from "./ManageWikiList.vue?vue&type=script&lang=ts"
export * from "./ManageWikiList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports